/**
 * 问卷调查
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 *
 * 主表
 * @param {*} Id
 * @returns
 */
export const SelectQuestionnairetById = (Id) => {
  return get('api/app/question?CurrentId=' + Id);
}

/**
*
* 明细
* @param {*} Id
* @returns
*/
export const SelectQuestionnairetDetailById = (Id) => {
  return post('/api/app/question/getQuerstionDetailListById/' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddQuestionnaire = (data) => {
  return post('/api/app/question/questionnaire', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyQuestionnaire = (data) => {
  return post('/api/app/question/editQuestionnaire', data, {});
}

/**
 * 更新数据记录(发布)
 * @param {*} data
 * @returns
 */
export const ModifyQuestion = (data) => {
  return put('/api/app/question', data, {});
}

/**
 * 分页获取问卷数据
 * @param {*} data
 * @returns
 */
export const GetDataQuestionnaireList = (data) => {
  return post('/api/app/question/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteQuestionnaire = (id) => {
  return del('/api/app/question/' + id, {}, {});
}

/**
 *
 * 通过问卷id获取问卷调研对象
 * @param {*} Id
 * @returns
 */
 export const GetQuestionObjectDataById = (Id) => {
  return get('api/app/question/'+Id+'/questionObjectDataById');
}


/**
 *
 * 获取问卷数据列表
 * @param {*}
 * @returns
 */
 export const GetQuestionDataByQueryModel = (data) => {
  return post('api/app/question/getQuestionDataByQueryModel',data,{});
}

/**
 *
 * 通过问卷Id获取问卷的答题情况
 * @param {*} Id
 * @returns
 */
 export const GetQuestionDataDetailResultById = (Id) => {
  return get('api/app/question/'+Id+'/questionDataDetailResultById');
}

/* 批量删除 */
export const DeleteQuestions = (data) => {
  return post('/api/app/question/delQuestions', data, {});
}